/**
 * inCust API
 *
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { FuelPumpNozzleRecApiModel } from './fuel-pump-nozzle-rec';

export interface FuelPumpRecApiModel {
  /**
   * Is available available for operations
   */
  available?: boolean;
  /**
   * Pump ID
   */
  id?: string;
  /**
   * Internal pump ID / Pump number
   */
  internal_id?: string;
  /**
   * Nozzles info
   */
  nozzles?: Array<FuelPumpNozzleRecApiModel>;
  /**
   * Pump status
   */
  status?: FuelPumpRecApiModelStatusEnum;
  /**
   * Pump status description
   */
  status_description?: string;
  /**
   * Linked terminal ID
   */
  terminal_id?: string;
}
export enum FuelPumpRecApiModelStatusEnum {
  Idle = 'idle',
  Filling = 'filling',
  EndOfTransaction = 'end-of-transaction',
  Offline = 'offline'
}
